import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../components/forms/Buttons/Button";
import { ArrowDownTrayIcon, PlusIcon } from "@heroicons/react/24/outline";
import ExportClassroom from "./ExportClassroom";
import { UserContext } from "../../../utils/contexts/UserContext";
import { exportAllClassroomPassesPDF } from "../../../services/olympiad/classroomService";

export default function ClassroomPageHeader({ onCreateClick, classrooms }) {
  const { user } = useContext(UserContext);
  const [t] = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="mb-4 flex items-center justify-between">
      <h1 className="text-2xl font-bold">{t("admin.classrooms")}</h1>
      <div className="flex items-center gap-2">
        <Button
          Icon={ArrowDownTrayIcon}
          text={t("admin.export")}
          onClick={() => setIsOpen(true)}
          color="primary"
        />
        <Button
          Icon={ArrowDownTrayIcon}
          color="success"
          text="Экспорт FULL"
          onClick={() => {
            exportAllClassroomPassesPDF(user?.exam_centers?.uuid).then(
              (res) => {
                window.open(res.file, "_blank");
              }
            );
          }}
        />
      </div>

      <ExportClassroom
        modalOpen={isOpen}
        setModalOpen={setIsOpen}
        classrooms={classrooms}
      />
      {/* <h1 className="text-2xl font-bold">{t("admin.classrooms")}</h1>
      <Button
        Icon={PlusIcon}
        text={t("admin.create_classroom")}
        onClick={onCreateClick}
        color="primary"
      /> */}
    </div>
  );
}
